import { render, staticRenderFns } from "./auditSetting.vue?vue&type=template&id=3fa232fc&scoped=true"
import script from "./auditSetting.vue?vue&type=script&lang=ts"
export * from "./auditSetting.vue?vue&type=script&lang=ts"
import style0 from "./auditSetting.vue?vue&type=style&index=0&id=3fa232fc&prod&lang=less"
import style1 from "./auditSetting.vue?vue&type=style&index=1&id=3fa232fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa232fc",
  null
  
)

export default component.exports